import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grin-tears': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M117.1 256.1c6.3-0.9 11.7 4.5 10.9 10.9-3.7 25.8-13.7 84-30.6 100.9-22 21.9-57.9 21.5-80.3-0.9-22.4-22.4-22.8-58.4-0.9-80.3 16.9-16.9 75.1-26.9 100.9-30.6zM623.8 286.7c21.9 21.9 21.5 57.9-0.8 80.2-22.4 22.4-58.4 22.8-80.3 0.9-16.9-16.9-26.9-75.1-30.6-100.9-0.9-6.3 4.5-11.7 10.8-10.8 25.8 3.7 84 13.7 100.9 30.6zM497.2 348.4c12.4 37.3 25.1 43.8 28.3 46.5-44.6 65.8-120 109.1-205.5 109.1s-160.9-43.3-205.5-109.1c3.1-2.6 15.8-9.1 28.3-46.5 33.4 63.9 100.3 107.6 177.2 107.6s143.8-43.7 177.2-107.6zM122.7 224.5c-2.4-0.3-5-2.5-49.5 6.9 12.4-125.4 118.1-223.4 246.8-223.4s234.4 98 246.8 223.5c-44.3-9.4-47.4-7.2-49.5-7-15.2-95.3-97.8-168.5-197.3-168.5s-182.1 73.2-197.3 168.5zM320 400c-51.9 0-115.3-32.9-123.3-80-1.7-10 7.9-18.4 17.7-15.3 26 8.3 64.4 13.1 105.6 13.1s79.7-4.8 105.6-13.1c10-3.2 19.4 5.4 17.7 15.3-8 47.1-71.4 80-123.3 80zM450.3 231.7c-3.1 0.9-7.2-0.1-9.3-3.7l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-1.9 3.2-5.8 4.8-9.3 3.7-3.6-1.1-6-4.6-5.7-8.3 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c0.3 3.8-2.1 7.2-5.7 8.3zM240 189.4c-12.3 0-23.8 7.8-31.5 21.6l-9.5 17c-1.9 3.2-5.8 4.8-9.3 3.7-3.6-1.1-6-4.6-5.7-8.3 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c0.3 3.8-2.1 7.2-5.7 8.3-3.1 1-7.2 0-9.3-3.7l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/grin-tears.js
// module id = 1757
// module chunks = 0